import noop, { nullNoop } from 'utils/noop';

import { IStorePrepaidCard } from './types';

export const storePrepaidCard = noop as (options: IStorePrepaidCard) => void;
export const getStoredPrepaidCard = nullNoop as () => null;
